import { types } from 'mobx-state-tree';
import createService from '../../utils/NeDBService';

export const ApplicationState = types.model('application', {
  name: types.string,
  customerId: types.number,
  customerName: types.string,
  initialized: types.Date,
  updated: types.maybe(types.Date)
});

export default app => createService(app, ApplicationState.name);


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/common/services/ApplicationState.ts